import React from 'react';

const HeaderSection = () => {
    return (
        <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4 dark:text-white">Purchase Credits</h1>
            <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                Choose the perfect credit package for your needs. <br />
                1 credit = 1 website.
            </p>
        </div>
    );
};

export default HeaderSection;